import { render, staticRenderFns } from "./CreateEnvironment.vue?vue&type=template&id=4ada09ac&scoped=true&"
import script from "./CreateEnvironment.vue?vue&type=script&lang=js&"
export * from "./CreateEnvironment.vue?vue&type=script&lang=js&"
import style0 from "./CreateEnvironment.vue?vue&type=style&index=0&id=4ada09ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ada09ac",
  null
  
)

export default component.exports